import script from "./Modal.vue?vue&type=script&setup=true&lang=js"
export * from "./Modal.vue?vue&type=script&setup=true&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=1ca267e3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca267e3"]])

export default __exports__